import pluralize from 'common/js_utils/pluralize';
import {
  timezoneDict,
  TimezoneTypes,
  DayTypes,
  dayTypesDict,
} from 'common/types/frequencySelector/frequencySelector';
import { I18n } from 'common/i18n';
import { map } from 'jquery';
import { sortBy } from 'lodash';
import moment from 'moment';
import { ScheduleSendValues } from '../../types/scheduleSend';

const scope = 'shared.components.schedule_send_report.modal.summary_section';

export const buildTranslationParams = (scheduleSendValues: ScheduleSendValues) => {
  const { frequencyConfig, recipients, name } = scheduleSendValues;
  const { count, week, type } = frequencyConfig.intervalInfo;
  const { timeZone, time } = frequencyConfig.timeInfo;
  const { startDate, endDate } = frequencyConfig.datesInfo;
  const { startDateString } = getFormattedDates(startDate, endDate);
  const recipientString =
    recipients.length > 1 ? I18n.t('recipients', { scope }) : I18n.t('recipient', { scope });
  const everyString = count > 1 ? `${count} ${I18n.t(pluralize(type), { scope })}` : I18n.t(type, { scope });
  return {
    days: generateDaysString(scheduleSendValues),
    everyString,
    recipientCount: recipients.length,
    recipientString,
    reportName: name,
    scope,
    startDate: startDateString,
    time: getFormattedTime(time, timeZone),
    week,
  };
};

export const getFormattedTime = (time: string | undefined, timeZone: string | undefined) => {
  const timeValue = moment(time, 'HH:mm');
  if (timeValue.isValid()) {
    const timezoneString = timezoneDict[timeZone as TimezoneTypes];
    return `${moment(timeValue).format('hh:mm A')} ${timezoneString}`;
  }
  return '';
};

export const generateDaysString = (scheduleSendValues: ScheduleSendValues) => {
  const { frequencyConfig } = scheduleSendValues;
  const daysInfo = frequencyConfig.intervalInfo.days;
  const daysTranslated = map(
    sortBy(
      map(daysInfo, (day: DayTypes) => dayTypesDict[day]),
      'id',
    ),
    (dayObj) => dayObj.label,
  );
  return daysTranslated.join(', ');
};

export const getFormattedDates = (startDate: string | undefined, endDate: string | undefined) => {
  const startDateValue = moment(startDate, 'L');
  const endDateValue = moment(endDate, 'L');
  const startDateString = startDateValue.isValid() ? moment(startDateValue).format('LL') : '';
  const endDateString = endDateValue.isValid() ? moment(endDateValue).format('LL') : '';
  return { startDateString, endDateString, endDateValue };
};
